
import Menu from './Compartido/Menu.jsx';
import BannerPropiedad from './FichaPropiedad/BannerPropiedad.jsx';
import DatosPropiedad from './FichaPropiedad/DatosPropiedad.jsx';
import Footer from './Compartido/Footer.jsx';
import '../../../../css/web/bedloophotel/ficha.css';

const FichaPropiedad = (props) => {
    return (
        <main>
            <Menu
                destinos={props.destinos}
                sobrenosotros={props.textosobrenosotros}
                clientes={props.textoclientes}
                propietarios={props.textopropietarios}
                servicios={props.textoservicios}
                experiencias={props.experiencias}
                idiomas={props.idiomas}
                lang={props.lang}
                tiposcasas={props.tiposcasas}
                config={props.websgrupo}
                textopropiedades={props.textopropiedades}
                edificios={props.edificios}
                marcas={props.marcas}
                ruta={props.ruta}
                destinoslarga={props.destinoslarga}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                numblog={props.numblog}
                numfaqs={props.numfaqs}
                paginapersonalizada={props.paginapersonalizada}
            />
            <div className="bh-ficha">
                <BannerPropiedad
                    propiedad={props.propiedad}
                    ruta={props.ruta}
                    lang={props.lang}
                />
                <DatosPropiedad
                    propiedad={props.propiedad}
                    servicios={props.servicios}
                    politicas={props.politicas}
                    calendario={props.calendario}
                    diasbloqueados={props.diasbloqueados}
                    primerdialibre={props.primerdialibre}
                    lang={props.lang}
                    config={props.config}
                    extras={props.extras}
                    llegada={props.llegada}
                    salida={props.salida}
                    adultos={props.adultos}
                    ninos={props.ninos}
                    bebes={props.bebes}
                    configweb={props.websgrupo}
                    moneda={props.moneda}
                    destino={props.eldestino}
                    diasbloqueadossolos={props.diasbloqueadossolos}
                    diasbloqueadoscal={props.diasbloqueadoscal}
                    comentarios={props.comentarios}
                    ruta={props.ruta}
                />
            </div>
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    );
}

export default FichaPropiedad;
